import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, { formatDate, parseDate} from "react-day-picker/moment" // , formatDay

import 'react-day-picker/lib/style.css';
import 'moment/locale/he'

export class CalendarDay2 extends React.Component{
    constructor(props) {
    super(props);
    this.state = {
      selectedDay: undefined,
      isEmpty: true,
      isDisabled: false,
    }
  }

  handleDayChange = (selectedDay, modifiers, dayPickerInput) => {
    const { tpc } = this.props
    const input = dayPickerInput.getInput()
    this.setState({
      selectedDay,
      isEmpty: !input.value.trim(),
      isDisabled: modifiers.disabled === true,
    })
    ////if ((input.value.trim() || selectedDay === undefined)) // invalid
      //console.log('CalendarDay2 HandleDayChange Am I invalid??', input.value.trim())
        //return
    
    const d = selectedDay === undefined? "" : selectedDay.getDate() + "/" + (selectedDay.getMonth()+1) + "/" + selectedDay.getFullYear()
    return this.props.handleChangeDate(d, tpc.name)
  }

  render() {
    const { selectedDay, isEmpty } = this.state;
    const format = "D/M/YYYY"    
    const cn = (!isEmpty && !selectedDay) ? {className: "date-input-invalid"} : {}
    var value = this.props.value
    //if (!(!isEmpty && !selectedDay)){
    //    console.log("valid date input = ", this.state.selectedDay)
    //}
    return (
        <DayPickerInput
          value={value}
          formatDate={formatDate} 
          parseDate={parseDate} 
          format={format} 
          placeholder={format}
          onDayChange={this.handleDayChange}
          dayPickerProps={{
              selectedDays: selectedDay,
              localeUtils: MomentLocaleUtils, 
              locale:"he"
            }} 
          inputProps={cn}
        />
    );
  }
}

/*    MAYBE needed for calendar2
    <p>
      {isEmpty && 'Please type or pick a day'}
      {!isEmpty && !selectedDay && 'This day is invalid'}
      {selectedDay && isDisabled && 'This day is disabled'}
      {selectedDay &&
        !isDisabled &&
        `You chose ${selectedDay.toLocaleDateString()}`}
    </p>
*/
          